export default __webpack_public_path__ + "static/media/Android.70ba52db.png";